"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line no-use-before-define
const react_1 = __importDefault(require("react"));
const moment_1 = __importDefault(require("moment"));
const apollo_boost_1 = require("apollo-boost");
const react_hooks_1 = require("@apollo/react-hooks");
const ActionButtons_1 = __importDefault(require("coact/pages/modules/pageAction/ActionButtons"));
const DataTableView_1 = __importDefault(require("../../ui/DataTableView"));
const InventoryAdjustmentInfoStatus_1 = require("../InventoryAdjustmentInfoStatus");
const DataTableField_1 = require("../../stockRecordWorkflow/ui/DataTableField");
const CREATE_INVENTORY_ADJUSTMENT_INFO = apollo_boost_1.gql `
  mutation {
    createInventoryAdjustmentInfo
  }
`;
const GET_INVENTORY_ADJUSTMENT_INFOS = apollo_boost_1.gql `
  query {
    getInventoryAdjustmentInfos{
      _id
      sn
      status
      submittedAt
      createdAt
    }
  }
`;
const fields = [
    {
        label: '單號',
        width: 100,
        textAlign: DataTableField_1.TextAlignment.Left,
        toFormat(info) {
            return info.sn;
        },
    },
    {
        label: '狀態',
        width: 100,
        textAlign: DataTableField_1.TextAlignment.Left,
        toFormat(info) {
            if (info.status === InventoryAdjustmentInfoStatus_1.InventoryAdjustmentInfoStatus.Created) {
                return '已創建';
            }
            if (info.status === InventoryAdjustmentInfoStatus_1.InventoryAdjustmentInfoStatus.Deleted) {
                return '已刪除';
            }
            if (info.status === InventoryAdjustmentInfoStatus_1.InventoryAdjustmentInfoStatus.Finished) {
                return '已完成';
            }
            return info.status;
        },
    },
    {
        label: '創建日期',
        width: 100,
        textAlign: DataTableField_1.TextAlignment.Left,
        toFormat(info) {
            if (info.createdAt === null)
                return '';
            return moment_1.default(info.createdAt).format('YYYY/MM/DD').toString();
        },
    },
    {
        label: '認列日期',
        width: 100,
        textAlign: DataTableField_1.TextAlignment.Left,
        toFormat(info) {
            if (info.submittedAt === null)
                return '';
            return moment_1.default(info.submittedAt).format('YYYY/MM/DD').toString();
        },
    },
];
const header = {
    getUniqueId(info) {
        return info._id;
    },
};
function InventoryAdjustmentInfosUIView(props) {
    const { data, loading, refetch } = react_hooks_1.useQuery(GET_INVENTORY_ADJUSTMENT_INFOS);
    const [createInventoryAdjustmentInfo] = react_hooks_1.useMutation(CREATE_INVENTORY_ADJUSTMENT_INFO);
    if (loading)
        return react_1.default.createElement(react_1.default.Fragment, null);
    const onMouseUp = (index) => {
        props.history.push(`/inventoryAdjustment/${data.getInventoryAdjustmentInfos[index]._id}`);
    };
    const actions = [
        {
            text: '創建',
            props: {},
            onClick: () => __awaiter(this, void 0, void 0, function* () {
                yield createInventoryAdjustmentInfo().then(() => refetch());
            }),
        },
    ];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ActionButtons_1.default, { actions: actions, classes: null }),
        react_1.default.createElement(DataTableView_1.default, { header: header, fields: fields, createMouseUpHandler: () => onMouseUp, data: data.getInventoryAdjustmentInfos })));
}
exports.default = InventoryAdjustmentInfosUIView;
